import React from "react";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { Paper, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TranslationContent from "../../../Translations/TranslationContent";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import ReplayIcon from '@mui/icons-material/Replay';
import "../loadingDots.css";
import { useViewport } from "../../../Context/ViewportProvider";
import QueryStatsIcon from '@mui/icons-material/QueryStats';


const CompareError = ({ error, toggleDialogShow, fetchComparisonData }) => {
  const  { width, height } = useViewport();
  const navigate = useNavigate();

  if(error) {
    return(
      <Grid container mb={2}>
        <Grid xs={12}>
          <Paper sx={{padding: "7px", display: "inline-flex", width: "100%"}} elevation={5}>
            {width > 750 && height > 500 ?
              <Typography color="primary" variant="subtitle1" sx={{alignContent: "center"}}>
                <b onClick={() => navigate("/compare")} style={{cursor: "pointer", marginTop: "auto", marginBottom: "auto"}}>
                  <TranslationContent contentID="compare" />
                </b>
                <KeyboardArrowRightIcon sx={{verticalAlign:"middle"}} />
              </Typography>
            :
              <Stack direction="row" sx={{alignContent: "center", marginTop: "auto", marginBottom: "auto"}}>
                <QueryStatsIcon color="primary" fontSize="small" sx={{cursor: "pointer"}} onClick={() => navigate("/compare")} />
                <KeyboardArrowRightIcon color="primary" sx={{verticalAlign:"middle"}} />
              </Stack>
            }
            <Typography color="primary" variant="body2" sx={{marginTop: "auto", marginBottom: "auto", opacity: 0.5}}>
              <TranslationContent contentID="noData" />
            </Typography>
            <Button size="small" onClick={() => toggleDialogShow()} variant="contained" sx={{marginRight: 0, marginLeft: "auto"}}><TranslationContent contentID="manageData" /></Button>
          </Paper>
        </Grid>
        <Grid xs={12} mt={2}>
          <Paper sx={{p: 2, textAlign: "center"}}>
            <Typography mb={3}><TranslationContent contentID="oopsSomethingWentWrong" /></Typography>
            <Button variant="outlined" onClick={() => fetchComparisonData()}>
              <ReplayIcon />
              &nbsp;&nbsp;
              <TranslationContent contentID="retry" />
            </Button>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default CompareError;